import formatDataBR from './formatDataBR';

export default function (valor) {
  const date = new Date(`${valor} 00:00:01`);
  const formatedDate = formatDataBR(valor);

  if (!isNaN(date.getTime())) {
    switch (date.getDay()) {
      case 0: return `${formatedDate} - Domingo`;
      case 1: return `${formatedDate} - Segunda`;
      case 2: return `${formatedDate} - Terça`;
      case 3: return `${formatedDate} - Quarta`;
      case 4: return `${formatedDate} - Quinta`;
      case 5: return `${formatedDate} - Sexta`;
      case 6: return `${formatedDate} - Sábado`;
      default: return '';
    }
  }
  return valor;
}
